import "src/decidim/initiatives/application"
import "src/decidim/initiatives/identity_selector_dialog"
import "src/decidim/initiatives/scoped_type"

// Images
require.context("../images", true)

// CSS
import "stylesheets/initiatives.scss"
